var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EditSquare"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit Square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M12 2.75012C5.063 2.75012 2.75 5.06312 2.75 12.0001C2.75 18.9371 5.063 21.2501 12 21.2501C18.937 21.2501 21.25 18.9371 21.25 12.0001",
    stroke: "#FE5858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.528 4.30388V4.30388C18.535 3.42488 17.018 3.51688 16.139 4.50988C16.139 4.50988 11.77 9.44488 10.255 11.1579C8.73804 12.8699 9.85004 15.2349 9.85004 15.2349C9.85004 15.2349 12.354 16.0279 13.848 14.3399C15.343 12.6519 19.734 7.69288 19.734 7.69288C20.613 6.69988 20.52 5.18288 19.528 4.30388Z",
    stroke: "#FE5858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M15.0098 5.80078L18.6048 8.98378",
    stroke: "#FE5858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e4e56920498a7a709ff990f06948b9c4.svg";
export { ForwardRef as ReactComponent };